import {bigLockIcon} from '@img/index.js'

export default function FlatRateBox() {
    return (
        <div className="flex items-center gap-3 bg-(--accent-green-dim) rounded-full p-3 mt-3">
            <img src={bigLockIcon} alt="Flat Rate" className="w-8 h-8 shrink-0"/>
            <div>
                <strong className="block text-sm">Flat Rate</strong>
                <p className="text-xs mb-0!">No Surge. No KM or Minute Charges</p>
            </div>
        </div>
    )
}
